import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export interface SuccessorAccountEntry {
  ownerUuid: string;
  ownerName: string;
  investmentsCount: number;
}

export function useGetMySuccessorAccounts() {
  return useQuery({
    queryKey: ["successors", "as-successor"],
    queryFn: async () => {
      const res = await axiosInstance.get<SuccessorAccountEntry[]>(
        "/successors/as-successor"
      );
      return res.data;
    },
    staleTime: 1000 * 15,
    retry: false,
  });
}
